export const PageTitle = ({ badge, title, subtitle, flash = false, testId = "page-title" }) => (
  <div className="rise mx-auto max-w-4xl px-6 pb-10 pt-16 text-center sm:pt-20">
    {badge && <span className="chip">{badge}</span>}
    <div className="relative mt-5">
      {flash && <div className="title-bolt absolute -inset-x-10 -inset-y-8" aria-hidden="true" data-testid={`${testId}-flash`} />}
      <span className={flash ? "title-strike" : ""}>
        <h1 className="outline-title relative text-5xl sm:text-6xl lg:text-7xl" data-testid={testId}>{title}</h1>
      </span>
    </div>
    {subtitle && <p className="mx-auto mt-5 max-w-3xl text-base font-semibold text-white md:text-lg">{subtitle}</p>}
  </div>
);
